// @deprecated since version 1.9.0
<template>
  <EmailConfirmSuccess />
</template>

<script>
import EmailConfirmSuccess from '../components/templates/EmailConfirmSuccess'

export default {
  components: {
    EmailConfirmSuccess
  }
}
</script>
